import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceAuth {
    lookupService = new APIServiceLookUp();

    async userLogin(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/interpreterLogin`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async IDPUserUpdate(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/IDPUserUpdate`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async IDPUserPasswordUpdate(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/IDPUserPasswordUpdate`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}